// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { Currency, CurrencyPrecision } from 'common/components/Number';

const Container = styled.div`
  display:flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: ${({ theme }) => theme.V2.fonts.h4.size}px;
`;

const Value = styled.div`
  display:flex;
  font-size: ${({ theme }) => theme.V2.fonts.massive.size}px;
  font-weight: ${({ theme }) => theme.V2.fonts.massive.weight};
  color: ${({ theme }) => theme.V2.colors.primary};
  margin-bottom: ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

const TotalCost = styled.div`
  display:flex;
  font-size: ${({ theme }) => theme.V2.fonts.subtitle.size}px;
`;

type Props = {
  label: string,
  value: string,
  totalCost: number
}

function PropositionSummaryMetric({ label, value, totalCost }: Props) {
  return (
    <Container>
      <Label>{label}</Label>
      <Value>{value}</Value>
      <TotalCost>
        <Currency value={totalCost} precision={CurrencyPrecision.DOLLARS} />
      </TotalCost>
    </Container>
  );
}

export default withTheme(translate('salesDashboard')(PropositionSummaryMetric));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/PropositionSummary/PropositionSummaryMetric.js